import { call, takeLatest, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  setFetchValidateTokenRequest,
  setFetchValidateTokenSuccess,
  setFetchValidateTokenFailure,
} from '../reducers/validateTokenReducer';

export const SAGA_VALIDATE_TOKEN = 'SAGA_VALIDATE_TOKEN';

export function sendGetValidateToken(payload) {
  return { type: SAGA_VALIDATE_TOKEN, payload };
}

const handleGetValidateToken = async ({ token }) =>
  axiosInstance.get('/api/reset/validateToken/' + token).then((res) => res.data);

export function* getValidateToken(action) {
  yield put(setSending);
  yield put(setFetchValidateTokenRequest);
  try {
    const response = yield call(handleGetValidateToken, action.payload);
    yield put(setFetchValidateTokenSuccess(response));
  } catch (error) {
    yield put(setFetchValidateTokenFailure(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForGetValidateToken() {
  yield takeLatest(SAGA_VALIDATE_TOKEN, getValidateToken);
}
